export default __webpack_public_path__ + "static/media/2cd43b_a4430f72c31e4fbe82d1dfe5be11ff8e_mv2.96166f6b.png";